<template>
  <div id="contenedor-licitaciones-toolbar">
    <v-toolbar flat>
      <div style="width: 150px" class="mr-2">
        <ejercicio-picker
          v-model="filtros.ejercicio"
          class="mr-2"
          sinPeriodo>
        </ejercicio-picker>
      </div>
      <div style="width: 350px" class="mr-2">
        <custom-text-field
          :value="filtros.buscarTexto"
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @input="buscar"
          @click:clear="limpiarBuscadorTexto"
        >
        </custom-text-field>
      </div>
      <filtros
        :licitaciones="listaLicitaciones"
        :filtros="filtros">
      </filtros>
      <v-spacer></v-spacer>
      <registrar-nueva-licitacion></registrar-nueva-licitacion>
    </v-toolbar>
    <div class="d-flex flex-wrap align-center px-1 pt-2">
      <v-chip
        v-if="filtros.buscarTexto"
        small
        close
        class="mr-2 mb-1"
        @click:close="limpiarBuscadorTexto">
        Busqueda: {{ filtros.buscarTexto }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import RegistrarNuevaLicitacion from '@/components/administracion/licitaciones/Nueva.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import Filtros from './Filtros.vue';

export default {
  name: 'ToolBarLicitaciones',
  props: {
    listaLicitaciones: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    Filtros,
    EjercicioPicker,
    CustomTextField,
    RegistrarNuevaLicitacion,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(valor) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = valor || '';
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    abrirCalendario() {
      this.$emit('abrirCalendario');
    },
    nuevo() {
      this.$emit('nuevaLicitacion');
    },
  },
};
</script>

<style lang="scss">
</style>
